import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, Repeat2, ArrowLeftRight, Shuffle, BarChart2, AlertTriangle, ArrowLeft } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { API_BASE } from "../config";
import "../styles/testModesPage.css";
import apiFetch from "../apiFetch";

const TEST_TYPES = [
  {
    id: "definitions",
    title: "Definitions Test",
    description: "Read a word and pick the correct definition from four choices",
    icon: <BookOpen size={28} />,
    color: "tm-indigo",
    available: true,
  },
  {
    id: "synonyms",
    title: "Synonyms Test",
    description: "Pick the word that means the same as the given word",
    icon: <Repeat2 size={28} />,
    color: "tm-teal",
    available: true,
  },
  {
    id: "antonyms",
    title: "Antonyms Test",
    description: "Pick the word that means the opposite of the given word",
    icon: <ArrowLeftRight size={28} />,
    color: "tm-orange",
    available: true,
  },
  {
    id: "mixed",
    title: "Mixed Test",
    description: "Random mix of definitions, synonyms and antonyms questions",
    icon: <Shuffle size={28} />,
    color: "tm-purple",
    available: true,
  },
];

export default function TestModesPage() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [progress, setProgress] = useState(null);

  useEffect(() => { document.title = "Test Modes — Owllet Reading Quest"; }, []);

  useEffect(() => {
    if (!userId) return;
    apiFetch(`/api/vocab-test/progress?userId=${userId}`)
      .then((r) => r.json())
      .then((d) => setProgress(d))
      .catch(() => {});
  }, [userId]);

  return (
    <div className="tm-page">
      <PageHeader pageTitle="Test Modes" pageSubtitle="Put everything you've learned to the test — no hints, no help, just you" />

      <div className="tm-body">
        {/* Progress summary */}
        {progress && (
          <div className="tm-progress-bar">
            <div className="tm-stat">
              <BarChart2 size={16} />
              <span>{progress.attempted} words attempted</span>
            </div>
            <div className="tm-stat tm-stat-green">
              <span>{progress.mastered} mastered</span>
            </div>
            {progress.weak > 0 && (
              <div className="tm-stat tm-stat-red">
                <AlertTriangle size={14} />
                <span>{progress.weak} weak words</span>
              </div>
            )}
          </div>
        )}

        <h2 className="tm-section-title">Choose a test type</h2>

        <div className="tm-grid">
          {TEST_TYPES.map((t) => (
            <div key={t.id} className={`tm-card ${t.color}`}>
              <div className="tm-card-icon">{t.icon}</div>
              <div className="tm-card-body">
                <h3>{t.title}</h3>
                <p>{t.description}</p>
              </div>
              <button
                className="tm-start-btn"
                onClick={() => navigate("/vocab-test/setup", { state: { testType: t.id } })}
              >
                Start →
              </button>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
